















import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { ExternalLinkIcon } from 'vue-feather-icons';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    ExternalLinkIcon,
  },
})
export default class GoToFlixcheckCreateCheckButton extends mixins(BaseMixin) {
  @Prop({ required: true, type: Boolean })
  loading!: boolean;
}
